<script>
import { mapGetters } from 'vuex'
import TitleCountReview from './titleCountReview'
import Order from './order'
import Pending from './pending'
import StockReview from './stockReview'

export default {
  name: 'CountReview',
  components: {
    TitleCountReview,
    Order,
    Pending,
    StockReview,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      inventory_count_review: 'retina/inventory/inventory_count_review',
      pending_results: 'retina/inventory/pending_results',
      total_spent: 'retina/inventory/total_spent',
      total_spent_quantity: 'retina/inventory/total_spent_quantity',
      total_stock: 'retina/inventory/total_stock',
      total_stock_quantity: 'retina/inventory/total_stock_quantity',
      total_pending_quantity: 'retina/inventory/total_pending_quantity',
    }),
  },
  methods: {},
}
</script>
<template>
  <div v-if="inventory_count_review">
    <div class="row">
      <div class="col-md-12 col-xl-5">
        <TitleCountReview />
      </div>
      <div class="col-md-12 col-xl-5">
        <!-- <QrCounterSpentProducts /> -->
      </div>
    </div>

    <div>
      <b-tabs id="menu-tabs"  active-nav-item-class="font-weight-bold text-blue" 
        nav-class="text-center" content-class="bg-white">
        <b-tab active title-link-class="m-0 px-1 py-2 pl-2 font-weight-light">
          <template #title>
            <i class="fas fa-clipboard-list fa-lg"></i>
            <br>
            Pedido
            <b-badge :variant="total_spent_quantity ? 'blue' : 'light'">{{ total_spent_quantity }}</b-badge>
          </template>
          <Order />
        </b-tab>
        <b-tab  title-link-class="m-0 px-1 py-2 pl-2 font-weight-light">
          <template #title>
            <i class="fas fa-bell fa-lg"></i>
            <br>
            Pendientes
            <b-badge :variant="total_pending_quantity ? 'blue' : 'light'">{{ total_pending_quantity }}</b-badge>
          </template>
          <Pending />
        </b-tab>
        <b-tab   title-link-class="m-0 px-1 py-2 pl-2 font-weight-light">
          <template #title>
            <i class="fas fa-dolly-flatbed fa-lg"></i>
            <br>
            Conteo
            <b-badge :variant="total_stock_quantity ? 'blue' : 'light'">{{ total_stock_quantity }}</b-badge>
          </template>
          <StockReview />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<style lang="scss">
@media screen and (max-width: 765px) {
  #menu-tabs .nav-item {
    width: 33.3333%;
  }
}
@media screen and (min-width: 766px) {
  #menu-tabs .nav-item {
    min-width: 110px;
  }
}
</style>